import { Button } from "../../components/Button";
import { Col, Container, Row } from "react-grid-system";
import { getMeetingsList } from "../../api/meeting/meeting";
import { Link, Outlet, useParams } from "react-router-dom";
import { MeetingsList } from "../../components/MeetingsList";
import { QueryLoader } from "../../components/Loader";
import { Search } from "../../components/Search";
import { Sidemenu } from "../../components/Sidemenu";
import { STab, STabList, STabPanel, STabs } from "../../styles/Tabs";
import { StyledPageHeader } from "../../styles/StyledPage";
import { useEffect } from "react";
import { useQuery } from "react-query";
import { useState } from "react";
import AddIcon from "../../assets/img/icons/add.svg";
import Modal from "react-modal";
import moment from "moment";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

export default function MeetingsPage() {
	const { axiosPrivate } = useAxiosPrivate();
	const params = useParams();

	const [phrase, setPhrase] = useState();
	const currentDate = new Date();

	const { isLoading: isFutureMeetingsLoading, data: futureMeetingsData } = useQuery(["futureMeetings", phrase], () =>
		getMeetingsList(
			axiosPrivate,
			moment().format("YYYY-MM-DD"),
			moment()
				.year(currentDate.getFullYear() + 2)
				.format("YYYY-MM-DD"),
			phrase
		)
	);

	const { isLoading: isOngoingMeetingsLoading, data: ongoingMeetingsData } = useQuery(["ongoingMeetings", phrase], () =>
		getMeetingsList(axiosPrivate, moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"), phrase)
	);

	const { isLoading: isArchiveMeetingsLoading, data: archiveMeetingsData } = useQuery(["archiveMeetings", phrase], () =>
		getMeetingsList(
			axiosPrivate,
			moment()
				.year(currentDate.getFullYear() - 3)
				.format("YYYY-MM-DD"),
			moment().format("YYYY-MM-DD"),
			phrase
		)
	);

	useEffect(() => {
		Modal.setAppElement("body");
	});

	return (
		<>
			{!params.id && (
				<Container>
					<Row style={{ marginTop: "2rem" }}>
						<Col sm={12} lg={2}>
							<Sidemenu />
						</Col>
						<Col sm={12} lg={10}>
							<StyledPageHeader>
								<h1>Meetings</h1>
								<div>
									<Search isWhite setPhrase={setPhrase} />
								</div>
							</StyledPageHeader>
							<STabs selectedTabClassName="is-selected" selectedTabPanelClassName="is-selected">
								<STabList>
									<STab>Future</STab>
									<STab>Ongoing</STab>
									<STab>Archive</STab>
								</STabList>
								<STabPanel>{isFutureMeetingsLoading ? <QueryLoader /> : <MeetingsList data={futureMeetingsData} />}</STabPanel>
								<STabPanel>{isOngoingMeetingsLoading ? <QueryLoader /> : <MeetingsList data={ongoingMeetingsData} />}</STabPanel>
								<STabPanel>{isArchiveMeetingsLoading ? <QueryLoader /> : <MeetingsList data={archiveMeetingsData} />}</STabPanel>
							</STabs>

							<Link to={"/add-meeting"}>
								<Button icon={AddIcon}>Add meeting</Button>
							</Link>
						</Col>
					</Row>
				</Container>
			)}
			<Outlet />
		</>
	);
}
